import React from "react";
import BaseButton from "./BaseButton";
import { ToTopOutlined } from '@ant-design/icons';
import { checkPermissions } from "@comps/commonFunctions";

const BaseImport = ({ modkey, permissionAction = "create", text, className, ...props }) => {
  if (modkey && !checkPermissions(modkey, permissionAction)) {
    return null;
  }

  const label = text || "Import";

  return (
    <BaseButton
      { ...props }
      aria-label={ label }
      title={ label }
      notify={ { title: label } }
      className={ ["import-button", "toolbar-icon-button", className].filter(Boolean).join(" ") }
    >
      <ToTopOutlined className="import-button-icon" />
    </BaseButton>
  );
};

BaseImport.displayName = "BaseImport";

export default BaseImport;
